var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7435 19.5056C14.147 21.7179 10.853 21.7179 9.25645 19.5056L0.990761 8.05236C-1.43377 4.69283 0.966764 2.52247e-06 5.1098 2.16028e-06L6.85504 2.0077e-06C8.18322 1.89159e-06 9.41147 0.705475 10.0807 1.85273C11.1615 3.70544 13.8385 3.70545 14.9192 1.85273C15.5884 0.705468 16.8167 1.13683e-06 18.1448 1.02072e-06L19.8901 8.68139e-07C24.0332 5.05943e-07 26.4337 4.69284 24.0092 8.05237L15.7435 19.5056Z",
    fill: "#F484E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeart);
export default __webpack_public_path__ + "static/media/icon-heart.cb096fcf9fa22f20b609fe1690b19e64.svg";
export { ForwardRef as ReactComponent };